/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '..';

const findContentWithRefs = ({
    brand, contentType, includeRefs, locale,
}) => gql`
{
    findContent(brand: "${brand}", environment: "${GRAPHQL_ENV}", contentType: "${contentType}", includeRefs: ${includeRefs}, locale: "${locale || 'en-us'}") {
      content
      __typename
    }
  }
`;

export default findContentWithRefs;
